import { render, staticRenderFns } from "./OneCheckType.vue?vue&type=template&id=bea534e0"
import script from "./OneCheckType.vue?vue&type=script&lang=js"
export * from "./OneCheckType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports